export default function validate(values) {
    let errors = {};

    if(!values.name) {
        errors.name = 'missingSiteName'
    }

    if(!values.type) {
        errors.type = 'missingStockLocationType'
    }

    // Validate deliveryTransitionHours for devices that require it
    if(values.type && (values.type.type === 'VIAL_FILLER' || values.type.type === 'POUCH_PACKAGER' || values.type.type === 'ATC2_POUCH_PACKAGER')) {
        const deliveryHours = values.device?.settings?.deliveryTransitionHours;

        if(!deliveryHours || deliveryHours === '' || deliveryHours === null || deliveryHours === undefined) {
            errors.deliveryTransitionHours = 'missingDeliveryTransitionHours';
        } else {
            const numValue = Number(deliveryHours);
            if(isNaN(numValue) || numValue <= 0) {
                errors.deliveryTransitionHours = 'invalidDeliveryTransitionHours';
            }
        }
    }

    return errors;
}
